/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable no-return-assign */
/* eslint-disable react/prop-types */
import React from 'react';
import { injectIntl } from 'react-intl';
import { MdErrorOutline } from 'react-icons/md';
import AppButton from '../app-button/AppButton';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    const { formatMessage } = this.props.intl;

    if (hasError) {
      // You can render any custom fallback UI
      return (
        <section className="app-container p-3 mt-5 mb-5">
          <div className="text-center">
            <MdErrorOutline style={{ fontSize: 60 }} />
            <h4>{formatMessage({ id: 'oops' })}</h4>
            <p className="mt-3 mb-3">
              {formatMessage({ id: 'something_went_wrong' })}
            </p>
            <AppButton
              btnText={formatMessage({ id: 'back_to_home_btn' })}
              // eslint-disable-next-line no-undef
              onClick={() => (window.location.href = '/')}
            />
          </div>
        </section>
      );
    }
    return children;
  }
}

export default injectIntl(ErrorBoundary);
